"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WaveDropAuthorPfp from "@/components/waves/drops/WaveDropAuthorPfp";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { DropAuthorBadges } from "@/components/waves/drops/DropAuthorBadges";
import { getWaveRoute } from "@/helpers/navigation.helpers";
interface MemeDropArtistInfoProps {
  readonly drop: ExtendedDrop;
}
export default function MemeDropArtistInfo(t0) {
  const $ = _c(35);
  const {
    drop
  } = t0;
  let t1;
  if ($[0] !== drop) {
    t1 = <WaveDropAuthorPfp drop={drop} />;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== drop.author.level) {
    t2 = !!drop.author.level && <UserCICAndLevel level={drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[2] = drop.author.level;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = `/${drop.author.handle ?? drop.author.primary_address}`;
  let t4;
  if ($[4] !== drop.author.handle) {
    t4 = drop.author.handle ? <UserProfileTooltipWrapper user={drop.author.handle}><span className="tw-mb-0 tw-text-md tw-font-semibold tw-leading-none">{drop.author.handle}</span></UserProfileTooltipWrapper> : <span className="tw-mb-0 tw-text-md tw-font-semibold tw-leading-none">{drop.author.handle}</span>;
    $[4] = drop.author.handle;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <Link href={t3} onClick={_temp} className="tw-no-underline">{t4}</Link>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = `meme-author-badges-${drop.id}`;
  let t7;
  if ($[9] !== drop.author || $[10] !== t6) {
    t7 = <DropAuthorBadges profile={drop.author} tooltipIdPrefix={t6} />;
    $[9] = drop.author;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="tw-size-[3px] tw-flex-shrink-0 tw-rounded-full tw-bg-iron-700" />;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== drop.created_at) {
    t9 = <WaveDropTime timestamp={drop.created_at} />;
    $[13] = drop.created_at;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = drop.winning_context?.decision_time ?? null;
  let t11;
  if ($[15] !== drop.rank || $[16] !== t10) {
    t11 = <div className="tw-ml-2"><WinnerDropBadge rank={drop.rank} decisionTime={t10} /></div>;
    $[15] = drop.rank;
    $[16] = t10;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== t11 || $[19] !== t2 || $[20] !== t5 || $[21] !== t7 || $[22] !== t9) {
    t12 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-1.5 tw-gap-y-1">{t2}{t5}{t7}{t8}{t9}{t11}</div>;
    $[18] = t11;
    $[19] = t2;
    $[20] = t5;
    $[21] = t7;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== drop.wave.id) {
    t13 = getWaveRoute({
      waveId: drop.wave.id,
      isDirectMessage: false,
      isApp: false
    });
    $[24] = drop.wave.id;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== drop.wave.name || $[27] !== t13) {
    t14 = <Link onClick={_temp2} href={t13} className="tw-leading-0 tw-mb-0 tw-text-[11px] tw-text-iron-500 tw-no-underline tw-transition tw-duration-300 tw-ease-out hover:tw-text-iron-300">{drop.wave.name}</Link>;
    $[26] = drop.wave.name;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t12 || $[30] !== t14) {
    t15 = <div className="tw-flex tw-flex-col tw-gap-y-1.5">{t12}{t14}</div>;
    $[29] = t12;
    $[30] = t14;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t1 || $[33] !== t15) {
    t16 = <div className="tw-flex tw-items-center tw-gap-x-3">{t1}{t15}</div>;
    $[32] = t1;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}
function _temp(e) {
  return e.stopPropagation();
}